import { QueryClient } from '@tanstack/react-query';

/**
 * Instancia global de TanStack Query.
 *
 * - staleTime de 30s: balanceamos frescura vs refetches en cada navegación.
 * - retry 1: errores transitorios sí reintentan, 401/403 ya manejados en el
 *   interceptor axios — no tiene sentido reintentar esos.
 * - refetchOnWindowFocus solo en dev (en prod genera ruido innecesario).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: import.meta.env.DEV,
    },
    mutations: {
      retry: 0,
    },
  },
});
